import customerService from '../../services/customer-service';

const state = () => ({

    loading: false,
    customers: [],
    error: ""
})

const actions = {
    getAll({ commit }) {
        commit('Loading', true);

        customerService.getAll()
            .then(
                customers => {
                    //console.log(customers);
                    commit('Success', customers.data);

                },
                error => commit('Failure', error)
            );
    },

}


const mutations = {
    Loading(state, status) {
        state.loading = status;
    },
    Success(state, customers) {
        state.customers = customers;
        state.loading = false;
    },
    Failure(state, error) {
        state.error = error;
    },


}

const getters = {
    CUSTOMERS: state => {
        return state.customers
    },

    CUSTOMER_ERROR: state => {
        return state.error
    },
    CUSTOMER_LOADING: state => {
        return state.loading
    },


}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}